module.exports = __webpack_public_path__ + "img/drivers.902f5695.png";